import React, { useState } from "react";
import '../styles/pages/About.css';

const definitions = {
  "Physical Capacity Evaluations (Functional Capacity Evaluations)": "The PCE/FCE is a comprehensive assessment used to determine an individual's physical abilities and limitations. It typically involves a series of tests and observations to evaluate strength, endurance, flexibility, and overall physical function. These tests are often used in occupational health to assess a person's ability to perform work-related tasks, especially after an injury or illness. The results can help guide rehabilitation plans and return-to-work decisions.",
  "Work Capacity Evaluations": "A WCE is an assessment used to determine an individual's ability to perform work-related tasks. It evaluates physical and sometimes mental capabilities to ensure that a person can safely and effectively carry out their job duties. This evaluation includes standardized functional testing along with specific job simulation to more accurately determine a worker’s capacity to return to a specific job role. WCEs are often used in cases of injury or illness to decide if an employee can return to work or if accommodations are needed.",
  "Jobsite Assessments": "Job Task Analysis identifies the specific tasks, skills, and physical demands required to perform a designated job role. This information can be used to create physical screening tests (i.e. Physical Capacity Tests) for hiring purposes, return-to-work evaluations, or to identify necessary accommodations for employees.",
  "Physical Capacity Test (Pre-employment/Post-offer)": "This is a screening test used to measure an individual's physical abilities related to a specific job position to determine if a person can safely perform the physical demands of a job. Information from this test can be used for hiring purposes, return-to-work evaluations, or to identify necessary accommodations for employees.",
  "Expert Witness Service": "Offering professional analysis and defense of the completed PCE, FCE, or WCE  for deposition and/or courtroom trial purposes."
};

function CenterTextWithPopup({ text, definition, expanded, setExpanded  }) {
  const [hovered, setHovered] = useState(false);
//   const [expanded, setExpanded] = useState(false);

  return (
    <div className="center_text_popup_container">
      <div
        className={"center_text " + (expanded ? "expanded" : "expandable")}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => setExpanded((prev) => ({ ...prev, [text]: !expanded }))}
        // onClick={() => setExpanded(!expanded)}
      >
        
        {expanded ? <div className="definition_boxes">{definition}</div> : <div className={"center_text_borders " + (expanded ? "expanded" : "expandable")}>{text}</div>}
        {/* </div> */}
      </div>
      {hovered && !expanded && (
        <div className="popup_box">
          {definition}
        </div>
      )}
      <div className="block_margin"></div>
    </div>
  );
}

function About() {

      // expandedState is an object: { "Physical Capacity Evaluations": true, ... }
  const [expandedState, setExpandedState] = useState({});
      
  // show all definitions of the center_text elements
  const expandAll = () => {
      let allExpanded = {};
      Object.keys(definitions).forEach(key => {
          allExpanded[key] = true;
      });
      setExpandedState(allExpanded);
  };

  // close all definitions
  const closeAll = () => {
      setExpandedState({});
  };

  // check if all definitions are expanded
  const areAllExpanded = () => {
      return Object.keys(definitions).every(key => expandedState[key]);
  };

  // toggle between expand all and close all
  const toggleExpandAll = () => {
      if (areAllExpanded()) {
          closeAll();
      } else {
          expandAll();
      }
  };

  return (
    <div>
      <article className="about">
        <p className="block_text">
          <span className="otr">Trevor Tash, OTR/L </span>
          has been an Occupational Therapist for nearly 30 years and has over 20 years’ experience specializing in
          Worker Rehabilitation Services for Workers Compensation claims, personal injury claims, and fitness for duty.
        </p>
      </article>
      <h6 className="services_header">
        &mdash;&mdash; Services Provided &mdash;&mdash;
      </h6>
      <div className="definitions">

        {/* <div className="block_margin"></div> */}
        {
          Object.entries(definitions).map(([key, value]) => (
            <CenterTextWithPopup
              key={key}
              text={key}
              definition={value}
              expanded={!!expandedState[key]}
              setExpanded={setExpandedState}
            />
          ))
        }
        <div className="details_button">
          <p onClick={toggleExpandAll} className="center_text link_text expandable">
            {areAllExpanded() ? "hide details" : "show details"}
          </p>
        </div>
        <div className="block_margin"></div>
        {/* <p className="center_text">
            Physical Capacity Evaluations 
        </p>
        <p className="center_text">
            Functional Capacity Evaluations
        </p>
        <p className="center_text">
            Work Capacity Evaluations 
        </p>
        <p className="center_text">
            Jobsite Assessments
        </p>
        <p className="center_text">
            Pre-employment testing.
        </p> */}
      </div>
      <article className="about">
        <p className="block_text">
          Please contact us for additional information and pricing.
          </p>
      </article>
      {/* <article className="about">
        <p className="block_text">
            <span className="otr">Trevor Tash, OTR/L </span>
            has been an Occupational Therapist for nearly 30 years and has over 20 years’ experience specializing in
            Worker Rehabilitation Services for Workers Compensation claims, personal injury claims, and fitness for duty. 
        </p>
        <p className="block_text">
            Tash Work Assessments specialize in Physical Capacity Evaluations, Functional Capacity Evaluations, 
            Work Capacity Evaluations, Jobsite Assessments, and Pre-employment Screening Tests.
        </p>
        <p className="block_text">
            At this time, we are not conducting assessments for disability applications. 
            <br />
            Please contact us for additional information and pricing.
        </p>
      </article> */}
    </div>
  );
}
export default About;